import React from 'react';
import { ListGroup } from 'react-bootstrap';
import PropTypes from 'prop-types';
import moment from 'moment';

const ShiftLogSummary = ({ logs, title }) => {
  if (!logs || logs.length === 0) {
    return null;
  }
  return (
    <ListGroup className="mt-5">
      <ListGroup.Item>
        <h4 className="mb-0">{title}</h4>
      </ListGroup.Item>
      {logs.map((log, index) => (
        <ListGroup.Item key={log._id || index} className="py-3">
          <div>
            <small className="mb-0">
              Updated by{' '}
              <span>
                <strong>{log.modifiedBy}</strong>{' '}
                <span className="text-muted">({log.modifiedByEmail})</span> on{' '}
                {moment(log.modifiedDate).format('lll')}
              </span>
            </small>
            <div className="small mt-3">
              <strong className="text-muted">Reason:</strong>{' '}
              {log.reason || '—'}
            </div>
            <div className="small mt-3">
              <strong className="text-muted">Old Shift:</strong>{' '}
              {moment(log.oldShiftStartDate).format('lll')} →{' '}
              {moment(log.oldShiftEndDate).format('lll')}
              <br />
              <strong className="text-muted">New Shift:</strong>{' '}
              {log.scheduleDetails?.shiftStart &&
                moment(log.scheduleDetails.shiftStart).format('lll')}{' '}
              →{' '}
              {log.scheduleDetails?.shiftEnd &&
                moment(log.scheduleDetails.shiftEnd).format('lll')}
            </div>
          </div>
        </ListGroup.Item>
      ))}
    </ListGroup>
  );
};

ShiftLogSummary.propTypes = {
  logs: PropTypes.array,
  title: PropTypes.string,
};

export default ShiftLogSummary;
